import { render, staticRenderFns } from "./VipCard.vue?vue&type=template&id=4a6bc992&scoped=true&"
import script from "./VipCard.vue?vue&type=script&lang=js&"
export * from "./VipCard.vue?vue&type=script&lang=js&"
import style0 from "./VipCard.vue?vue&type=style&index=0&id=4a6bc992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6bc992",
  null
  
)

export default component.exports